exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".sitedropdown-label {\n  font-size: 11px;\n  text-transform: uppercase;\n  font-weight: 'Bold';\n  padding-bottom: 8px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/styles/components/siteComponentStyle.less
// module id = 2660
// module chunks = 0